module.exports = __webpack_public_path__ + "static/media/email-loader.2a891200.gif";